import { useInitialLoadForDeepLinks } from '../common/hooks/use-initial-load-for-deep-links.hook';
import { Loader } from '../../components/loader/loader';
import { useEffect } from 'react';
import { history, URL_CONSTANTS } from '../../utils/history';

export const FarmNewDeepLinkContainer = () => {
  const { isOrgFetched, defaultOrg, isWorkspaceFetched, defaultWorkspace } =
    useInitialLoadForDeepLinks();

  // We only navigate after org is fetched, and if no org is found we wait for workspace to be fetched to navigate to workspace level
  const isOrgReady = isOrgFetched && defaultOrg;
  const isFallbackReady = isOrgFetched && !defaultOrg && isWorkspaceFetched;
  const shouldNavigate = isOrgReady || isFallbackReady;

  useEffect(() => {
    if (!shouldNavigate) return;

    let urlToNavigate = URL_CONSTANTS.HALL_OF_ENTITIES();

    if (defaultOrg?.id && defaultOrg?.workspace_id) {
      urlToNavigate =
        URL_CONSTANTS.HALL_OF_ENTITIES({
          workspaceId: defaultOrg.workspace_id,
          orgId: defaultOrg.id
        }) + `?action=CREATE-FARM`;
    } else if (defaultWorkspace?.id) {
      urlToNavigate = URL_CONSTANTS.HALL_OF_ENTITIES({
        workspaceId: defaultWorkspace.id
      });
    }

    history.push(urlToNavigate);
  }, [defaultOrg?.id, defaultOrg?.workspace_id, defaultWorkspace?.id, shouldNavigate]);

  return <Loader mask />;
};
